export const crmActivitiesArticle = {
  title: 'Customer CRM: Activities',
  slug: 'crm-activities',
  content: `Customer CRM: Activities

The Activities tab keeps your team aligned on follow-ups and meetings.

1) Activity feed
- Use the Activity Feed view to review recent CRM actions.
- Track updates such as new contacts, deal changes, and notes.

2) Calendar view
- Switch to Calendar to see scheduled work in a timeline.
- Use this view to plan outreach and meetings across the team.
`,
};
